export default __webpack_public_path__ + "static/media/updated-ISSO.83b35414.pdf";